<section class="auth">
  <aside class="auth-panel">
    <p class="kicker light">{{ lang.t('pfKicker') }}</p>
    @if (auth.user(); as user) {
      <h1>{{ user.name }}</h1>
      <p>{{ lang.t('pfP') }}</p>
    }
  </aside>

  <div class="auth-form">
    <p class="kicker">{{ lang.t('account') }}</p>
    <h2>{{ lang.t('pfDetails') }}</h2>
    @if (auth.user(); as user) {
      <dl class="profile-list">
        <div>
          <dt>{{ lang.t('pfName') }}</dt>
          <dd>{{ user.name }}</dd>
        </div>
        <div>
          <dt>{{ lang.t('pfEmail') }}</dt>
          <dd>{{ user.email }}</dd>
        </div>
        <div>
          <dt>{{ lang.t('pfPhone') }}</dt>
          <dd>{{ user.phone || lang.t('pfMissing') }}</dd>
        </div>
        <div>
          <dt>{{ lang.t('pfCountry') }}</dt>
          <dd>{{ user.country || lang.t('pfMissing') }}</dd>
        </div>
        <div>
          <dt>{{ lang.t('pfCash') }}</dt>
          <dd>{{ money(user.cash) }}</dd>
        </div>
      </dl>
    }
    <a class="btn primary" routerLink="/portfolio">{{ lang.t('pfBack') }}</a>
  </div>
</section>
